module.exports = __webpack_public_path__ + "f1404739766cbcd48eca0250fd09ae37.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/informations/aboutUs/Joe.png
// module id = 1482
// module chunks = 0